import {
  Glass,
  ScreenLabel,
  DisplayText,
  BodyText,
  BackNav,
} from "../../components/mobile/primitives";

/** Biomarker value detail screen — shows value, reference range, confidence, source */
export function FlowBiomarkerDetail() {
  return (
    <div style={{ padding: "0 16px", display: "flex", flexDirection: "column", gap: 14 }}>
      <BackNav label="Back" />

      {/* Hero value — centered, with subtle glow like featured insight card */}
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <ScreenLabel style={{ marginBottom: 6 }}>Vitamin D</ScreenLabel>
        <DisplayText size={42} color="var(--color-kin-gold-dark)">
          18
        </DisplayText>
        <BodyText size={12} color="var(--color-kin-muted)" weight={500} style={{ marginTop: 2 }}>
          ng/mL
        </BodyText>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 8,
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "rgba(240,184,0,0.15)",
          }}
        >
          <span
            style={{
              fontSize: 12,
              fontWeight: 800,
              color: "var(--color-kin-gold-dark)",
              fontFamily: "'Manrope', system-ui",
              lineHeight: 1,
            }}
          >
            ?
          </span>
        </div>
      </div>

      {/* Reference range indicator */}
      <Glass style={{ borderRadius: 18 }}>
        <div style={{ padding: "14px" }}>
          <ScreenLabel style={{ marginBottom: 10 }}>Reference Range</ScreenLabel>
          {/* Visual range bar */}
          <div style={{ position: "relative", height: 24, marginBottom: 8 }}>
            {/* Background track */}
            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 10,
                height: 4,
                borderRadius: 2,
                background: "rgba(0,0,0,0.06)",
              }}
            />
            {/* Normal range zone */}
            <div
              style={{
                position: "absolute",
                left: "30%",
                right: "10%",
                top: 10,
                height: 4,
                borderRadius: 2,
                background: "rgba(91,122,102,0.20)",
              }}
            />
            {/* Current value marker — uses the same circle+shadow pattern as processing nodes */}
            <div
              style={{
                position: "absolute",
                left: "18%",
                top: 6,
                width: 12,
                height: 12,
                borderRadius: 6,
                background: "var(--color-kin-gold-dark)",
                border: "2px solid #fff",
                boxShadow: "0 2px 6px rgba(240,184,0,0.3)",
              }}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <BodyText size={8} color="var(--color-kin-muted)" weight={500}>
              0
            </BodyText>
            <BodyText size={8} color="var(--color-kin-green-soft)" weight={500}>
              30 – 100 ng/mL
            </BodyText>
            <BodyText size={8} color="var(--color-kin-muted)" weight={500}>
              150
            </BodyText>
          </div>
        </div>
      </Glass>

      {/* Extraction details — metadata rows matching vault-setup integration rows */}
      <Glass style={{ borderRadius: 18 }}>
        <div style={{ padding: "0 14px" }}>
          {[
            ["Raw value", "18 ng/mL"],
            ["Confidence", "97%"],
            ["Date source", "Document date"],
            ["Normalization", "None applied"],
          ].map(([label, value], i) => (
            <div
              key={label}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "9px 0",
                borderBottom: i < 3 ? "1px solid rgba(0,0,0,0.05)" : "none",
              }}
            >
              <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                {label}
              </BodyText>
              <BodyText size={10} weight={500}>
                {value}
              </BodyText>
            </div>
          ))}
        </div>
      </Glass>

      {/* Source document — tappable link card */}
      <Glass style={{ borderRadius: 18, borderColor: "rgba(91,122,102,0.18)" }}>
        <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 8,
              background: "rgba(91,122,102,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-kin-green-soft)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <BodyText size={10} weight={600}>
              Blood Panel Feb 2026
            </BodyText>
            <BodyText size={8.5} color="var(--color-kin-muted)" weight={400}>
              Open source file
            </BodyText>
          </div>
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            stroke="var(--color-kin-green-soft)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M1.5 1l5 5-5 5" />
          </svg>
        </div>
      </Glass>
    </div>
  );
}
